import React from "react";
import { LegalPage } from "./LegalPage.js";
import { TERMS_SECTIONS } from "./content.js";

export function TermsPage() {
  return <LegalPage title="Terms of Service" sections={TERMS_SECTIONS} />;
}
